import React from 'react';
import back from '../../../assets/images/back.jpg';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import AirlinesIcon from '@mui/icons-material/Airlines';
import theme from '../../theme/Theme';

import styled from "styled-components";

const DivLogin = styled.div`
  background: linear-gradient(135deg, #040138 0%, #0a0a4f 100%);
   min-height: 100vh; /* 👈 chave */ 
   width: 100%; 
   display: flex; 
   flex-direction: column; 
   align-items: center; 
   justify-content:center; 
   padding: 60px 40px; 
   position: relative;  
     &:before { 
        content: "";
         position: absolute; 
         inset: 0; 
         background: url(${back}); 
         background-size: cover; 
         background-position: top center; 
         z-index: 0;
     }
`;
const Titulo = styled(Typography)`
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    position:relative;
    opacity: 0.8;
    z-index:2; 
    color:white;
    font-family: "Lucida Sans" !important;
    padding-top:20vh; 
    color:white;

`

export default function PageNotFound() {
    return (
        <>
            <ThemeProvider theme={theme}>
                <DivLogin>
                <Titulo variant="h3" gutterBottom>
                    <AirlinesIcon sx={{ fontSize: 50 }}></AirlinesIcon>PORTAL DO AGENTE
                </Titulo>
                <Titulo variant="h3" gutterBottom>
                    PÁGINA NÃO ENCONTRADA
                </Titulo>
                </DivLogin>
            </ThemeProvider>
        </>
    );
}